import * as React from "react";
const SvgBatteryHorizontal100PercentCharging20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18 4H0v12h18v-3h2V7h-2V4Zm-7.75 1L4 11.25h5L7.75 15 14 8.75H9L10.25 5Z",
      clipRule: "evenodd"
    })
  );
export default SvgBatteryHorizontal100PercentCharging20Px;
